export enum EndpointTypes {
  SingleEntity = 'SingleEntity',
  AllEntities = 'AllEntities',
  ModelData = 'ModelData',
  // Ones bellow are currenty used only for Media Plan.
  PostEntity = 'PostEntity',
  PutEntity = 'PutEntity',
  DeleteEntity = 'DeleteEntity',
  GetSingleEntity = 'GetSingleEntity',
  GetAllEntities = 'GetAllEntities',
  GetModelData = 'GetModelData',
}



// WEBPACK FOOTER //
// ./src/app/enums/enpoint-types.enum.ts